import React from 'react';

const AboutUs = () => (
	<div className="container main">
		<h2>À propos de nous</h2>
		<hr/>
		<div className="row">
			<div className="col-sm-6">
				<h4>Groupe de travail de l'OCDE sur la sécurité des produits de consommation</h4>
				<p>
					Le <em>portail mondial sur les rappels de produits</em> (<i>Global recalls</i> Portal) a été développé par le <a href="https://www.oecd.org/fr/sti/consommateurs/consumer-product-safety.htm">Groupe de travail de l’OCDE sur la sécurité des produits de consommation</a>.
					Il a pour mandat d’améliorer le partage d’informations et de promouvoir une plus grande coopération entre les autorités de surveillance du marché, de contrôle de conformité et de réglementation en matière de sécurité des produits du monde entier, en s’acquittant des missions suivantes :
				</p>
				<ul className={'rss-feed-options'}>
					<li>Identifier les problèmes de sécurité à un stade précoce</li>
					<li>Partager les pratiques et les évolutions en matière de politiques</li>
					<li>Résoudre les problèmes de sécurité de manière cohérente</li>
					<li>Soutenir les instances mondiales et régionales</li>
				</ul>
				<p>
					L’une des principales réalisations du Groupe de travail est la <a href="https://legalinstruments.oecd.org/fr/instruments/OECD-LEGAL-0459">Recommandation de l’OCDE sur la sécurité des produits de consommation</a>, laquelle expose les principes clés
					qui devraient être au cœur des cadres régissant la sécurité des produits de consommation aux niveaux national et international, et promeut une utilisation accrue du portail mondial
					sur les rappels de produits. Le Groupe de travail a également établi un grand nombre de ressources à l’intention des gouvernements et des entreprises dans l’optique d’améliorer l’efficacité des rappels de produits, qui sont accessibles sur son site web.
				</p>
			</div>
			<div className="col-sm-6">
				<h4 className="hidden-xs">&nbsp;</h4>
				<p>
					Le Groupe de travail est placé sous la responsabilité du <a href="https://www.oecd.org/sti/consumer/">Comité de la politique à l'égard des consommateurs</a>. Ces deux organes collaborent régulièrement sur des sujets liés à la protection des consommateurs, et mènent de nombreux projets et organisent de nombreuses manifestations en commun.
				</p>
				<p>
					En outre, le Groupe de travail collabore étroitement avec les organisations internationales intervenant dans le domaine de la sécurité des produits,
					notamment l’Association des nations de l’Asie du Sud-Est (ASEAN), la Commission européenne, la Conférence des Nations Unies sur le commerce et le développement (CNUCED),
					l’Organisation des États américains (OEA), l’Organisation internationale pour la santé et la sécurité des produits de consommation (ICPHSO) et le Réseau international de contrôle
					et de protection des consommateurs (RICPC). Il entretient également des liens étroits avec un certain nombre d’économies partenaires de l’OCDE.
				</p>
			</div>
		</div>
		<hr/>
		<div className="row">
			<div className="col-sm-6">
				<h4>Contactez-nous</h4>
				<p>
					Si vous avez des questions ou des commentaires sur le portail, merci de contacter le Secrétariat de l’OCDE à l’adresse <a href="mailto:GlobalRecallsdata@oecd.org">GlobalRecallsdata@oecd.org</a>
				</p>
			</div>
		</div>
	</div>
);

export default AboutUs;



// WEBPACK FOOTER //
// ./src/views/static/fr/about-us.js